import './WomansChoiceApplication.css';
import { Admin } from './admin/Admin';
import { Shop } from './shop/Shop';

const WomansChoiceApplication: React.FunctionComponent = () => {
  let adminMode = localStorage.getItem('a');
  if (adminMode) {
    return <Admin />;
  }
  return <Shop />;
};

export { WomansChoiceApplication };
